/* eslint-disable no-extra-boolean-cast */
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormControl } from '@angular/forms';
import { debounceTime, map, skipWhile, startWith, switchMap, take } from 'rxjs';
import { GraphApi, ExternalUserState } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { Store, select } from '@ngrx/store';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { AuthDebugFlagNames } from '@content-platform/web-angular-shared-util-auth';
import { DebugFlagsService } from '@content-platform/web-angular-shared-util-development';
import { LoggerService, actionEnum, eventTypeEnum } from '@content-platform/web-angular-shared-util-logging';
import { trim } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/legacy-dialog";
import * as i2 from "@content-platform/web-angular-administration-shared-data-access-graph-api";
import * as i3 from "@content-platform/web-angular-shared-util-logging";
import * as i4 from "@ngrx/store";
import * as i5 from "@content-platform/web-angular-shared-util-development";
import * as i6 from "@angular/common";
import * as i7 from "@angular/forms";
import * as i8 from "@angular/material/legacy-list";
import * as i9 from "@angular/material/legacy-button";
import * as i10 from "@angular/material/legacy-form-field";
import * as i11 from "@angular/material/legacy-input";
import * as i12 from "@angular/material/legacy-checkbox";
import * as i13 from "@angular/material/legacy-autocomplete";
import * as i14 from "@angular/material/legacy-core";
import * as i15 from "@angular/material/icon";
import * as i16 from "ngx-pipes";
const _c0 = a0 => ({ "debug-flag-with-metadata": a0 });
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const user_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", user_r7);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("\n                ", user_r7.displayName, " (", user_r7.mail, ")\n            ");
} }
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_error_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "\n              You cannot impersonate yourself.\n            ");
    i0.ɵɵelementEnd();
} }
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "\n              Username not found.\n            ");
    i0.ɵɵelementEnd();
} }
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n          ");
    i0.ɵɵelementStart(2, "input", 19);
    i0.ɵɵlistener("ngModelChange", function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r5); const flag_r6 = i0.ɵɵnextContext(2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onUpdateFlagMetaData(flag_r6, $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\n          ");
    i0.ɵɵelementStart(4, "mat-autocomplete", 20, 3);
    i0.ɵɵlistener("optionSelected", function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_Template_mat_autocomplete_optionSelected_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r3.selectUser($event)); });
    i0.ɵɵtext(6, "\n            ");
    i0.ɵɵtemplate(7, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_option_7_Template, 2, 3, "mat-option", 21);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtext(9, "\n          ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10, "\n          ");
    i0.ɵɵtemplate(11, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_error_11_Template, 2, 0, "mat-error", 22);
    i0.ɵɵtext(12, "\n            ");
    i0.ɵɵtemplate(13, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_mat_error_13_Template, 2, 0, "mat-error", 22);
    i0.ɵɵtext(14, "\n        ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const auto_r8 = i0.ɵɵreference(5);
    i0.ɵɵnextContext(2);
    const itemCheckbox_r9 = i0.ɵɵreference(11);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matAutocomplete", auto_r8)("readonly", itemCheckbox_r9 == null ? null : itemCheckbox_r9.checked)("formControl", ctx_r3.userSearchCtrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("displayWith", ctx_r3.displayFn);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(8, 7, ctx_r3.filteredUsers$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r3.userSearchCtrl == null ? null : ctx_r3.userSearchCtrl.hasError("loggedUserFound")) && !ctx_r3.impersonated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.userSearchCtrl == null ? null : ctx_r3.userSearchCtrl.hasError("userNotFound"));
} }
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0, "\n          ");
    i0.ɵɵelementStart(1, "input", 24);
    i0.ɵɵlistener("ngModelChange", function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_ng_template_4_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const flag_r6 = i0.ɵɵnextContext(2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onUpdateFlagMetaData(flag_r6, $event)); });
    i0.ɵɵtwoWayListener("ngModelChange", function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_ng_template_4_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const flag_r6 = i0.ɵɵnextContext(2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r3.flagMetadata[flag_r6.name], $event) || (ctx_r3.flagMetadata[flag_r6.name] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2, "\n        ");
} if (rf & 2) {
    const flag_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("name", "", flag_r6.name, "-metadata");
    i0.ɵɵpropertyInterpolate("placeholder", flag_r6.metadataHint);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.flagMetadata[flag_r6.name]);
} }
function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 17);
    i0.ɵɵlistener("click", function DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_Template_mat_form_field_click_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onFieldClick($event)); });
    i0.ɵɵtext(1, "\n        ");
    i0.ɵɵtemplate(2, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_div_2_Template, 15, 9, "div", 18);
    i0.ɵɵtext(3, "\n        ");
    i0.ɵɵtemplate(4, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_ng_template_4_Template, 3, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtext(6, "\n      ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const defaultInputType_r11 = i0.ɵɵreference(5);
    const flag_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", flag_r6.inputType === "auto-complete")("ngIfElse", defaultInputType_r11);
} }
function DebugFlagsDialogComponent_mat_list_item_15_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-item", 12);
    i0.ɵɵtext(1, "\n     ");
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtext(3, "\n      ");
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n      ");
    i0.ɵɵtemplate(7, DebugFlagsDialogComponent_mat_list_item_15_mat_form_field_7_Template, 7, 2, "mat-form-field", 15);
    i0.ɵɵtext(8, "\n    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, "\n      ");
    i0.ɵɵelementStart(10, "mat-checkbox", 16, 1);
    i0.ɵɵlistener("ngModelChange", function DebugFlagsDialogComponent_mat_list_item_15_Template_mat_checkbox_ngModelChange_10_listener() { const flag_r6 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.getSelectionValue(flag_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, "\n    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, flag_r6.hasMetadata));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(flag_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", flag_r6.hasMetadata);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r3.setCheckboxValue(flag_r6));
} }
const IMPERSONATE_USER_FLAG = 'impersonate_user';
export class DebugFlagsDialogComponent {
    constructor(dialogRef, data, graphApi, logger, store, debugFlagService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.graphApi = graphApi;
        this.logger = logger;
        this.debugFlagService = debugFlagService;
        this.debugFlags = [];
        this.flagSettingsList = [];
        this.flagMetadata = {};
        this.flagValues = {};
        this.userSearchCtrl = new FormControl();
        this.loginUser$ = store.pipe(select(authSelectors.getADUser));
        this.data = this.data || { flags: [], settings: {} };
        this.debugFlags = this.data.flags || [];
        // Convert settings object to array for use in selection list
        this.flagSettingsList = Object.keys(this.data.settings || {}).map(key => {
            this.flagMetadata[key] = this.data.settings[key];
            this.flagValues[key] = this.makeSelectionValue(key, this.flagMetadata[key] || false);
            return this.flagValues[key];
        });
    }
    validateEmail(emailControl) {
        const user = emailControl.value;
        if (emailControl.value && this.loggedInUserEmail && this.loggedInUserName) {
            if (typeof user === 'string') {
                if (user.trim().toLowerCase() === this.loggedInUserEmail.toLowerCase() ||
                    user.trim() === this.loggedInUserName.toLowerCase()) {
                    return {
                        loggedUserFound: 'logged in user found'
                    };
                }
            }
            else if (typeof user === 'object') {
                const userName = `${user.surname} ${user.givenName}`;
                if (user.mail.trim().toLowerCase() === this.loggedInUserEmail.toLowerCase() ||
                    userName.trim().toLowerCase() === this.loggedInUserName.toLowerCase()) {
                    return {
                        loggedUserFound: 'logged in user found'
                    };
                }
            }
            else {
                return {
                    userNotFound: 'user not found'
                };
            }
        }
        return null;
    }
    ngOnInit() {
        this.userSearchCtrl = new FormControl('', [this.validateEmail.bind(this)]);
        this.loginUser$.subscribe(({ profile }) => {
            if (this.debugFlagService) {
                if (this.debugFlagService.hasDebugFlag(AuthDebugFlagNames.Impersonate)) {
                    this.loggedInUserName = profile.name;
                    this.loggedInUserEmail = profile.mail;
                    this.impersonated = true;
                }
                else {
                    this.loggedInUserName = profile.name;
                    this.loggedInUserEmail = profile.unique_name;
                }
            }
        });
        this.debugFlags
            .filter(flag => flag.inputType === 'auto-complete')
            .forEach(flag => this.userSearchCtrl.setValue(this.flagMetadata[flag.name]));
        this.filteredUsers$ = this.userSearchCtrl.valueChanges.pipe(startWith(''), skipWhile(val => trim(val) === ''), debounceTime(500), switchMap(user => this.graphApi.searchUsers(trim(user))), map(res => res.filter(output => (output.mail !== this.loggedInUserEmail &&
            output.userState !== ExternalUserState.PENDING_ACCEPTANCE))));
    }
    makeSelectionValue(flagName, value) {
        const selectionValue = this.flagValues[flagName] || {};
        selectionValue[flagName] = value;
        return selectionValue;
    }
    getSelectionValue(flag) {
        // set valid user value to flagvalues
        if (flag.name === IMPERSONATE_USER_FLAG &&
            this.userSearchCtrl.value &&
            typeof this.userSearchCtrl.value === 'object' &&
            !this.userSearchCtrl.hasError('loggedUserFound')) {
            if (!!this.userSearchCtrl.value) {
                this.flagValues[flag.name] = this.makeSelectionValue(flag.name, '');
                this.userSearchCtrl.setValue('');
            }
            else {
                this.flagValues[flag.name] = this.makeSelectionValue(flag.name, this.userSearchCtrl.value);
            }
        }
        else if (flag.name === IMPERSONATE_USER_FLAG &&
            this.userSearchCtrl.value &&
            typeof this.userSearchCtrl.value !== 'object' &&
            !this.userSearchCtrl.hasError('loggedUserFound')) {
            this.flagValues[flag.name] = this.makeSelectionValue(flag.name, '');
            this.userSearchCtrl.setValue('');
        }
        else if (flag.name !== IMPERSONATE_USER_FLAG) {
            this.flagValues[flag.name] = this.makeSelectionValue(flag.name, true);
        }
        // check for value whether it is selected earlier and remove duplicate
        if (this.flagSettingsList.includes(this.flagValues[flag.name])) {
            const index = this.flagSettingsList.indexOf(this.flagValues[flag.name]);
            if (index !== -1) {
                this.flagSettingsList.splice(index, 1);
            }
        }
        else {
            // Check for flagvalues and avoid pushing empty / undefined value if any
            if (!!this.flagValues[flag.name]) {
                this.flagSettingsList.push(this.flagValues[flag.name]);
            }
        }
    }
    onFieldClick($event) {
        // Make it so it won't check the box
        $event.stopPropagation();
    }
    onUpdateFlagMetaData(flag, formValue) {
        const flagSetting = this.flagValues[flag.name];
        if (flagSetting) {
            flagSetting[flag.name] = formValue;
        }
    }
    updateReduceFlagSettings(data) {
        // Convert list back to settings object
        return data.reduce((collector, current) => {
            Object.keys(current).forEach(key => (collector[key] = current[key]));
            return collector;
        }, {});
    }
    logtoMegabeacon(data) {
        this.logger
            .doLogMegaBeacon(eventTypeEnum.DEBUG_FLAG, actionEnum.CREATE, '', data)
            .pipe(take(1))
            .subscribe(res => res);
    }
    setCheckboxValue(flag) {
        return this.flagSettingsList.find(obj => obj[flag.name]);
    }
    cancel() {
        this.dialogRef.close();
    }
    selectUser(event) {
        this.userSearchCtrl.setValue(event.option.value);
        this.flagValues[IMPERSONATE_USER_FLAG] = this.makeSelectionValue(IMPERSONATE_USER_FLAG, this.userSearchCtrl.value);
        if (!!this.flagValues[IMPERSONATE_USER_FLAG]) {
            this.flagSettingsList.push(this.flagValues[IMPERSONATE_USER_FLAG]);
        }
    }
    displayFn(user) {
        if (!user) {
            return '';
        }
        else {
            return `${user.displayName} (${user.mail})`;
        }
    }
    static { this.ɵfac = function DebugFlagsDialogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugFlagsDialogComponent)(i0.ɵɵdirectiveInject(i1.MatLegacyDialogRef), i0.ɵɵdirectiveInject(MAT_LEGACY_DIALOG_DATA, 8), i0.ɵɵdirectiveInject(i2.GraphApi), i0.ɵɵdirectiveInject(i3.LoggerService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.DebugFlagsService, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DebugFlagsDialogComponent, selectors: [["app-debug-flags-dialog"]], standalone: false, decls: 26, vars: 5, consts: [["flagSelectionList", ""], ["itemCheckbox", ""], ["defaultInputType", ""], ["auto", "matAutocomplete"], ["mat-icon-button", "", "id", "modal-close-icon", 1, "no-hover-effect", 3, "click"], ["aria-label", "Close"], ["mat-dialog-title", ""], ["mat-dialog-content", ""], ["dense", "", 1, "list"], ["class", " pad_0 list-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["mat-raised-button", "", "color", "accent", "cdkFocusInitial", "", 1, "dbf-button", 3, "click", "mat-dialog-close"], ["mat-button", "", 1, "dbf-button", 3, "click"], [1, "pad_0", "list-item", 3, "ngClass"], [1, "flex-box"], [1, "pad_0"], ["class", "pad_0 form-field", 3, "click", 4, "ngIf"], [1, "checkbox", 3, "ngModelChange", "ngModel"], [1, "pad_0", "form-field", 3, "click"], [4, "ngIf", "ngIfElse"], ["matInput", "", "placeholder", "Search Users", 3, "ngModelChange", "matAutocomplete", "readonly", "formControl"], [3, "optionSelected", "displayWith"], ["class", "user-options", 3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "user-options", 3, "value"], ["matInput", "", 3, "ngModelChange", "name", "placeholder", "ngModel"]], template: function DebugFlagsDialogComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtext(0, "\n");
            i0.ɵɵelementStart(1, "button", 4);
            i0.ɵɵlistener("click", function DebugFlagsDialogComponent_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.cancel()); });
            i0.ɵɵtext(2, "\n  ");
            i0.ɵɵelementStart(3, "mat-icon", 5);
            i0.ɵɵtext(4, "close");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5, "\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(6, "\n\n");
            i0.ɵɵelementStart(7, "h1", 6);
            i0.ɵɵtext(8, "Debug Flags");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(9, "\n\n");
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵtext(11, "\n  ");
            i0.ɵɵelementStart(12, "mat-list", 8, 0);
            i0.ɵɵtext(14, "\n    ");
            i0.ɵɵtemplate(15, DebugFlagsDialogComponent_mat_list_item_15_Template, 13, 6, "mat-list-item", 9);
            i0.ɵɵpipe(16, "orderBy");
            i0.ɵɵtext(17, "\n  ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(18, "\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(19, "\n\n");
            i0.ɵɵelementStart(20, "button", 10);
            i0.ɵɵlistener("click", function DebugFlagsDialogComponent_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.logtoMegabeacon(ctx.flagSettingsList)); });
            i0.ɵɵtext(21, "OK");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(22, "\n");
            i0.ɵɵelementStart(23, "button", 11);
            i0.ɵɵlistener("click", function DebugFlagsDialogComponent_Template_button_click_23_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.cancel()); });
            i0.ɵɵtext(24, "CANCEL");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(25, "\n\n\n\n");
        } if (rf & 2) {
            i0.ɵɵadvance(15);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(16, 2, ctx.debugFlags, "name"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("mat-dialog-close", ctx.updateReduceFlagSettings(ctx.flagSettingsList));
        } }, dependencies: [i6.NgClass, i6.NgForOf, i6.NgIf, i7.DefaultValueAccessor, i7.NgControlStatus, i7.NgModel, i7.FormControlDirective, i1.MatLegacyDialogClose, i1.MatLegacyDialogTitle, i1.MatLegacyDialogContent, i8.MatLegacyList, i8.MatLegacyListItem, i9.MatLegacyButton, i10.MatLegacyError, i10.MatLegacyFormField, i11.MatLegacyInput, i12.MatLegacyCheckbox, i13.MatLegacyAutocomplete, i13.MatLegacyAutocompleteTrigger, i14.MatLegacyOption, i15.MatIcon, i6.AsyncPipe, i16.OrderByPipe], styles: ["\n\n.list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%] {\n  height: 70px !important;\n  width: 100% !important;\n  border: none !important;\n  font-size: 12px;\n  color: #616c7d;\n  display: flex;\n  flex-direction: row;\n}\n.user-options[_ngcontent-%COMP%] {\n  height: unset;\n  line-height: 32px;\n  font-size: 14px;\n}\n.checkbox[_ngcontent-%COMP%] {\n  right: 0px;\n  position: absolute;\n  margin: 0;\n}\n  .checkbox .mat-checkbox-layout {\n  padding: 0;\n  margin: 0;\n}\n.form-field[_ngcontent-%COMP%] {\n  margin: 0;\n  padding: 0;\n  font-size: 12px;\n  width: 85%;\n}\n.pad_0[_ngcontent-%COMP%] {\n  padding: 0;\n}\n[_nghost-%COMP%]     .mat-list-base[dense] .mat-list-item .mat-list-item-content {\n  padding: 0;\n}\n  .mat-list-base[dense] .mat-list-item:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n  .debug-flag .mat-dialog-container {\n  color: #616c7d;\n  padding: 24px !important;\n  border-radius: 4px !important;\n  display: block !important;\n  box-sizing: border-box !important;\n  overflow: auto !important;\n  outline: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n.flex-box[_ngcontent-%COMP%] {\n  width: 320px;\n}\n[_nghost-%COMP%]     .mat-dialog-content {\n  overflow-x: hidden;\n  margin: 0 -11px;\n  text-align: left !important;\n}\n  .debug-flag .mat-dialog-container .mat-dialog-content div {\n  margin-top: 0px;\n}\n.dbf-button[_ngcontent-%COMP%] {\n  margin-top: 10px;\n  margin-right: 5px;\n  float: right;\n  height: 32px;\n  width: 96px;\n}\n.mat-dialog-actions[_ngcontent-%COMP%] {\n  padding: 8px 0;\n  display: flex;\n  flex-wrap: wrap;\n  min-height: 52px;\n  align-items: right;\n  margin-bottom: -24px;\n}\n#modal-close-icon[_ngcontent-%COMP%] {\n  cursor: pointer;\n  background: transparent;\n  z-index: 200;\n  top: 3px;\n  position: relative;\n  color: rgba(0, 0, 0, 0.15);\n  left: 320px;\n}\n#modal-close-icon[_ngcontent-%COMP%]:hover {\n  background-color: transparent;\n}\n  .mat-checkbox .mat-checkbox-frame {\n  border-style: double;\n  border-width: 2px !important;\n}\n[_nghost-%COMP%]     .mat-flat-button.mat-accent, \n.mat-raised-button.mat-accent[_ngcontent-%COMP%], \n.mat-fab.mat-accent[_ngcontent-%COMP%], \n.mat-mini-fab.mat-accent[_ngcontent-%COMP%] {\n  background-color: #33b27d;\n}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DebugFlagsDialogComponent, { className: "DebugFlagsDialogComponent", filePath: "libs/reusable-ui/feature-flags/src/lib/debug-flags-dialog/debug-flags-dialog.component.ts", lineNumber: 30 }); })();
//# sourceMappingURL=debug-flags-dialog.component.js.map